module.exports = __webpack_public_path__ + "img/users-light.5057ae20.png";